import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { SearchMovieFilterInterface } from '../shared/entities/search-movie-filter.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { SearchMovieFilterItemComponent } from '../search-movie-filter-item/search-movie-filter-item.component';
import { movieFilter, starFilter, userFilter } from '../shared/search-filter-options';
import { SearchMovieService } from '../shared/search-movie.service';

@Component({
  selector: 'search-filters-dropdown',
  standalone: true,
  imports: [CommonModule, DropdownModule, FontAwesomeModule, FormsModule, SearchMovieFilterItemComponent],
  templateUrl: './search-filters-dropdown.component.html',
  styleUrl: './search-filters-dropdown.component.scss'
})
export class SearchFiltersDropdownComponent {
  private readonly searchService = inject(SearchMovieService);
  filterOptions: SearchMovieFilterInterface[] = [movieFilter, starFilter, userFilter];
  selectedFilter: SearchMovieFilterInterface = this.filterOptions[0];

  onFilterChange() {
    this.searchService.setFilter(this.selectedFilter);
  }
}
